import { useEffect } from 'react';

export const useLockBodyScroll: (isLocked: boolean) => void = (isLocked) => {
    useEffect(() => {
        const previous = document.body?.style?.overflow ?? '';
        document.body.style.overflow = isLocked ? 'hidden' : 'visible';

        return () => {
            document.body.style.overflow = previous;
        };
    }, [isLocked]);
};
